export const googlePlayABN =
  'https://play.google.com/store/apps/details?id=com.abnamro.nl.mobile.payments&hl=nl';
export const appStoreABN = 'https://apps.apple.com/nl/app/abn-amro/id439728011';
